import React from 'react';
import ShareRedirect from './share-redirect';

const ShareCommunity = () => <ShareRedirect shareType="community" />;

export default ShareCommunity;
